<template>
  <div class="d-flex flex-row">
    <div><span class="fa fa-solid fa-lock mr-5"></span></div>
    <div class="text-left">{{ message ? message : "This field is locked because RTSM Integration is enabled" }}</div>
  </div>
</template>
<script>
export default {
  props: {
    message: { type: String, default: "" }
  }
};
</script>
